import React from "react";
import { IssueChildrenType, IssueItemType } from "./issueType";
import { ReportContentEnum, ReportParentContentEnum } from "./report";

export type QuestionType = {
  id: string;
  topic: string;
  title: string;
};
export type QuestionContentType = {
  reply: string;
  ticketType?: string;
};

export interface ImageItemType {
  src: string;
  path: string;
  text: string;
}

export interface CategoryType {
  id: string;
  categoryName: string;
  iconPath: string;
  sortCode: 1;
  parentId: string;
  questions: QuestionType[];
  childrenNode: CategoryType[];
  showTooltip?: boolean;
  display: boolean;
  title?: string;
  externalLink?: string;
}

export const enum TemplateFlagEnum {
  SelectCategory = "selectCategory",
  SelectQuestion = "selectQuestion",
  AnswerQuestion = "answerQuestion",
  Feedback = "feedback",
}

export const enum ReplyActionEnum {
  "answerQuestion" = 1,
  "templateFlag" = 2,
  "selectQuestion" = 3,
}
export const enum ComponentTypeEnum {
  Customer = "Customer",
  Robot = "Robot",
  Dialog = "Dialog",
  AI = "AI",
}

export interface historyChatContentType {
  answer: string;
  question: string;
}

export interface ChatContentType {
  id?: string;
  issueTypeItem?: IssueItemType | null;
  type: ComponentTypeEnum;
  uniqueKey: string;
  message?: string;
  data:
    | CategoryType[]
    | QuestionType[]
    | QuestionContentType
    | IssueChildrenType[]
    | string[]
    | GuideMenuConfigType
    | RobotAIKeywordItem[];
  template?: React.ComponentType<any>;
  showSubmitTicket?: boolean;
  title?: string;
  aiTypingStatus?: boolean;
  artificialStop?: boolean;
  templateFlag?: number | string;
  templateProps?: object; // 组件参数
  parentContentInfo?: {
    parentContent: string;
    parentContentId: string;
    parentContentType: ReportParentContentEnum;
  };
  showPrinter?: boolean;
  isHiddenBubble?: boolean; // 是否隐藏聊天气泡
  questionName?: string;
  printerOperationType?: "add" | "modify";
  rootSourceType?: TagTypeEnum;
  showTechAIFooter?: boolean;
  lng?: string; // 语言参数
  isNormal?: boolean; // 是否是正常的回答
  requestId?: string; // 本次请求的唯一标识
}

export interface QuestionTagType {
  externalLink: "string";
  id: string;
  idType: number;
  languages: "string";
  sortCode: 0;
  tagName: "string";
  tagStatusName: "string";
  tagType: TagTypeEnum;
  tagTypeName: "string";
  showTooltip?: boolean;
}

export interface RobotBannerType {
  bannerId: number | string;
  description: string;
  h5Url: string;
  languageCode: string;
  mobileFileId: number | string;
  mobileFileUrl: string;
  pcFileId: number | string;
  pcFileUrl: string;
  sortCode: number;
  status: true;
  topic: string;
}

export const enum RobotAIKeywordType {
  "hot" = 1,
  "navigation" = 2,
  "printprep" = 3,
  "binding" = 4,
}
export interface RobotAIKeywordItem {
  id: string;
  keyword: string;
  languageCode: RobotAIKeywordType;
  status: boolean;
}

export const enum OriginType {
  "web" = 1,
  "app" = 2,
}
export interface GuideMenuItemType {
  description: string;
  fileId: string;
  fileUrl: string;
  relateContent: string;
  relateId: string;
  relateType: ReportContentEnum;
  sortCode: string;
  title: string;
  id: string;
  tagType: TagTypeEnum;
  commonLanguageVO: QuestionTagType;
  configRelateVOList?: Record<string, any>[];
}

export const enum GuideMenuTypeEnum {
  "customGuide" = 1,
  "techAIGuide" = 2,
}

export const enum IMConfigTypeEnum {
  "generalFAQ" = 1,
  "techAiFAQ" = 2,
  "feedback" = 3,
}

export const enum FeedbackTypeEnum {
  "like" = 1,
  "dislike" = 2,
}

export interface GuideMenuConfigType {
  content: string;
  list: GuideMenuItemType[];
  languageCode: string;
  status: boolean;
}

export enum TagTypeEnum {
  "Default" = 0,
  "Tech" = 1,
  "General" = 2,
  "Cooperation" = 3,
  "MakerWorld" = 4,
}

export interface CategoryType {
  id: string;
  categoryName: string;
  iconPath: string;
  sortCode: 1;
  parentId: string;
  questions: QuestionType[];
  childrenNode: CategoryType[];
  showTooltip?: boolean;
  display: boolean;
  title?: string;
  externalLink?: string;
}

export interface CategoryType {
  id: string;
  categoryName: string;
  iconPath: string;
  sortCode: 1;
  parentId: string;
  questions: QuestionType[];
  childrenNode: CategoryType[];
  showTooltip?: boolean;
  display: boolean;
  title?: string;
  externalLink?: string;
}

export interface RobotBannerType {
  bannerId: number | string;
  description: string;
  h5Url: string;
  languageCode: string;
  mobileFileId: number | string;
  mobileFileUrl: string;
  pcFileId: number | string;
  pcFileUrl: string;
  sortCode: number;
  status: true;
  topic: string;
}

export interface ImageItemType {
  src: string;
  path: string;
  text: string;
}

export interface QuestionTagType {
  externalLink: "string";
  id: string;
  idType: number;
  languages: "string";
  sortCode: 0;
  tagName: "string";
  tagStatusName: "string";
  tagType: TagTypeEnum;
  tagTypeName: "string";
  showTooltip?: boolean;
}
